








import { defineClassComponent } from '@/hooks'
import { onMounted, ref } from '@vue/composition-api'
import { Track } from '@/utils'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          // 埋点页面名称
          page: '首页',
        }))

        onMounted(() => {
          this.loading.value = false
        })
      }

      // 加载状态
      loading = ref(true)
    },
)
